import React from 'react';

function Terms() {
  return (
    <div className="min-h-screen bg-[#0B0F17] text-gray-100 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
          Terms and Conditions
        </h1>
        
        <div className="space-y-8 text-gray-400">
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="leading-relaxed">
              By accessing and using IIM Interview's services, you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Use of Services</h2>
            <p className="leading-relaxed">
              Our services are designed to help you prepare for interviews. You agree to use these services 
              only for lawful purposes and in accordance with these Terms. Any misuse, including but not limited to, spamming our platform, using automated bots, or engaging in any activity that disrupts our services, is strictly prohibited and will be legally dealt with.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. User Accounts</h2>
            <p className="leading-relaxed">
              You are responsible for maintaining the confidentiality of your account credentials and for all 
              activities that occur under your account.  If you suspect unauthorized use of your account, you must notify us immediately. We reserve the right to suspend or terminate accounts engaged in suspicious or fraudulent activity.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Intellectual Property</h2>
            <p className="leading-relaxed">
            All content, including but not limited to AI-generated questions, responses, and feedback, is protected by intellectual property rights. You may not copy, modify, reproduce, or distribute any content without our explicit permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">5. Limitation of Liability</h2>
            <p className="leading-relaxed">
              We strive to provide reliable services but make no guarantees about their accuracy, reliability, or suitability for your specific needs. We are not responsible for any direct, indirect, incidental, or consequential damages arising from your use of our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">6. Service Availability</h2>
            <p className="leading-relaxed">
              While we strive to provide uninterrupted service, we do not guarantee continuous availability. We reserve the right to modify, suspend, or discontinue any part of our services at any time without prior notice.
            </p>  
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">7. Amendments to Terms</h2>
            <p className="leading-relaxed">
            We may update these Terms from time to time. Continued use of our services after changes are posted constitutes your acceptance of the revised Terms.            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Terms; 